import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const limitField = (label: string) =>
  z
    .number({ error: `${label} is required` })
    .int(`${label} must be a whole number`)
    .positive(`${label} must be greater than 0`);

export const rateLimitDefaultsSchema = z.object({
  keyword_monitoring_calls_per_min: limitField("Keyword monitoring limit"),
  influencer_monitoring_requests_per_min: limitField(
    "Influencer monitoring limit",
  ),
  source_monitoring_calls_per_min: limitField("Source monitoring limit"),
});

export type RateLimitDefaultsSchema = z.infer<typeof rateLimitDefaultsSchema>;

export const useRateLimitForm = () => {
  return useForm<RateLimitDefaultsSchema>({
    resolver: zodResolver(rateLimitDefaultsSchema),
    mode: "onChange",
    defaultValues: {
      keyword_monitoring_calls_per_min: undefined,
      influencer_monitoring_requests_per_min: undefined,
      source_monitoring_calls_per_min: undefined,
    },
  });
};
